import { PageProps } from 'gatsby'
import { Fragment, ReactElement } from 'react'

import { GlobalStyles } from '@/theme/GlobalStyles'

import { CtaBar } from './CtaBar'
import { Footer } from './Footer'
import { MainNav } from './MainNav'

type Props = {
  children: ReactElement
  pageProps: PageProps
}

export const Layout = ({ children }: Props) => {
  return (
    <Fragment>
      <GlobalStyles />
      <MainNav />
      <main>{children}</main>
      <CtaBar />
      <Footer />
      <div id="lightbox-container" />
    </Fragment>
  )
}
